import { render } from "./event_team.vue?vue&type=template&id=1d5c7796&scoped=true"
import script from "./event_team.vue?vue&type=script&lang=js"
export * from "./event_team.vue?vue&type=script&lang=js"

import "./event_team.vue?vue&type=style&index=0&id=1d5c7796&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5c7796"]])

export default __exports__